import { render, staticRenderFns } from "./ExportFile.vue?vue&type=template&id=4c8d5ace"
import script from "./ExportFile.vue?vue&type=script&lang=js"
export * from "./ExportFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports